import React from 'react'
const DialogInputLabel = ({ titleTip = '', label = '', className = '' }) => {
    return (
        <div className={`track-body-title ${className || ''}`}>
            <div className="track-body-title-content">{label}</div>
            {titleTip ? (
                <a href="void:0" className="track-body-title-tip">
                    {titleTip}
                </a>
            ) : null}
        </div>
    )
}

export default DialogInputLabel
